import React from 'react';
import Layout from '../components/Layout';
import { Card } from '../components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { ShieldCheck, Users, KeyRound, Layers, Lock, UserCog } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import UsersTab from '../components/access-control/UsersTab';
import RolesTab from '../components/access-control/RolesTab';
import RoleProfilesTab from '../components/access-control/RoleProfilesTab';
import PermissionsTab from '../components/access-control/PermissionsTab';
import UserPermissionsTab from '../components/access-control/UserPermissionsTab';

const AccessControl = () => {
  const { user } = useAuth();
  const isAdmin = user?.is_superuser || (user?.roles || []).includes('System Manager');

  if (!isAdmin) {
    return (
      <Layout>
        <div className="p-10 text-center" data-testid="access-denied">
          <Lock className="w-12 h-12 text-gray-300 mx-auto mb-3" />
          <h2 className="text-lg font-semibold text-gray-800">Access Denied</h2>
          <p className="text-sm text-gray-500">Only a System Manager can manage access control.</p>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="p-6 max-w-[1500px] mx-auto" data-testid="access-control-page">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-10 bg-orange-100 rounded-lg flex items-center justify-center">
            <ShieldCheck className="w-6 h-6 text-orange-600" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Access Control</h1>
            <p className="text-sm text-gray-500">Users, roles, role profiles and DocType permissions (ERPNext-style)</p>
          </div>
        </div>

        <Card className="p-5">
          <Tabs defaultValue="users">
            <TabsList className="mb-5">
              <TabsTrigger value="users" data-testid="tab-users"><Users className="w-4 h-4 mr-1" />Users</TabsTrigger>
              <TabsTrigger value="roles" data-testid="tab-roles"><KeyRound className="w-4 h-4 mr-1" />Roles</TabsTrigger>
              <TabsTrigger value="profiles" data-testid="tab-profiles"><Layers className="w-4 h-4 mr-1" />Role Profiles</TabsTrigger>
              <TabsTrigger value="permissions" data-testid="tab-permissions"><ShieldCheck className="w-4 h-4 mr-1" />Role Permissions</TabsTrigger>
              <TabsTrigger value="user-permissions" data-testid="tab-user-permissions"><UserCog className="w-4 h-4 mr-1" />User Permissions</TabsTrigger>
            </TabsList>
            <TabsContent value="users"><UsersTab /></TabsContent>
            <TabsContent value="roles"><RolesTab /></TabsContent>
            <TabsContent value="profiles"><RoleProfilesTab /></TabsContent>
            <TabsContent value="permissions"><PermissionsTab /></TabsContent>
            <TabsContent value="user-permissions"><UserPermissionsTab /></TabsContent>
          </Tabs>
        </Card>
      </div>
    </Layout>
  );
};

export default AccessControl;
